import React from "react";
import { Box, VStack, Text, Button, Icon } from "@chakra-ui/react";
import { BsPlayCircle } from "react-icons/bs";

/**
 * DemoEmptyState - Prominent hero card shown when user has 0 agendas.
 * Makes the demo the unmissable primary CTA for first-time users.
 */
const DemoEmptyState = ({
  onDemoClick,
  onSmartAgendaClick,
  isDemoLoading = false,
}) => {
  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="#E2E0F0"
      borderRadius="12px"
      p="32px"
      mb="16px"
      textAlign="center"
    >
      <VStack spacing="16px">
        {/* Icon */}
        <Box
          bg="#F0F0FF"
          borderRadius="full"
          w="56px"
          h="56px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon as={BsPlayCircle} w="28px" h="28px" color="#4C47CC" />
        </Box>

        {/* Text */}
        <VStack spacing="8px">
          <Text
            fontSize="16px"
            fontWeight="600"
            color="#0C001C"
            fontFamily="Geist, sans-serif"
            lineHeight="1.4"
          >
            See Townhall in action
          </Text>
          <Text
            fontSize="13px"
            fontWeight="400"
            color="#6B7280"
            fontFamily="Geist, sans-serif"
            lineHeight="1.5"
            maxW="360px"
          >
            Take a 60-second interactive demo with simulated participants. See
            real-time engagement tracking, live activities, and more.
          </Text>
        </VStack>

        {/* Buttons */}
        <VStack spacing="10px" pt="4px">
          <Button
            bg="#4C47CC"
            color="white"
            fontSize="14px"
            fontWeight="700"
            fontFamily="Geist, sans-serif"
            borderRadius="8px"
            px="20px"
            py="10px"
            h="auto"
            isLoading={isDemoLoading}
            disabled={isDemoLoading}
            transition="all 0.2s"
            _hover={{
              bg: "#3A37B3",
              transform: "translateY(-1px)",
            }}
            _active={{
              transform: "translateY(0px)",
            }}
            _disabled={{
              bg: "#B8B2C0",
              cursor: "not-allowed",
              transform: "none",
            }}
            onClick={onDemoClick}
            leftIcon={<Icon as={BsPlayCircle} w="16px" h="16px" />}
            iconSpacing="6px"
            data-testid="demo-empty-state-button"
          >
            Try Townhall
          </Button>

          <Button
            variant="link"
            color="#4C47CC"
            fontSize="13px"
            fontWeight="600"
            fontFamily="Geist, sans-serif"
            _hover={{ color: "#3A37B3", textDecoration: "none" }}
            onClick={onSmartAgendaClick}
            data-testid="smart-agenda-empty-state-button"
          >
            Or create one manually →
          </Button>
        </VStack>
      </VStack>
    </Box>
  );
};

export default DemoEmptyState;
